/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useCookieConsent } from "@/src/provider/CookieConsent/CookieConsentProvider";
import { useEffect } from "react";
import { gaInitialize, gaSet, gaTerminate } from "@/src/services/googleAnalyticsService";

export default function useGoogleAnalytics() {
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (!hasConsent("analytics")) {
      gaTerminate();
      return;
    }

    gaInitialize();
    gaSet({ anonymizeIp: false });
  }, [hasConsent]);
}
